export enum ProgressStatus {
	START = 0,
	WORKING = 1,
	DONE = 2,
}
